import React from "react";
import PropTypes from "prop-types";
import Loading from "./loading/loading";
import NoElements from "./no-elements/no-elements";
import FormConfirm from "components/form/form-confirm";
import { injectIntl } from "react-intl";

const QueryResponseHandler = ({ intl, error, loading, elements, children, msgId = "common.noelements" }) => {
  if (loading) {
    return <Loading />;
  }

  if (error) {
    return (
      <>
        <FormConfirm show error hideCloseButton label={intl.formatMessage({ id: "common.graphql.error" })} />
        <NoElements msgId={msgId} />
      </>
    );
  }

  if (!elements || typeof elements === "undefined") {
    return <NoElements msgId={msgId} />;
  }

  if (Array.isArray(elements) && !elements?.length) {
    return <NoElements msgId={msgId} />;
  }

  return children;
};

QueryResponseHandler.propTypes = {
  /**
   * Error graphql
   */
  error: PropTypes.object,
  /**
   * Indica si la query está cargando
   */
  loading: PropTypes.bool,
  /**
   * Conjunto de datos devueltos
   */
  elements: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /**
   * Clave del mensaje en caso de no haber elementos, por defecto (common.noelements)
   */
  msgId: PropTypes.string,
};

export default injectIntl(QueryResponseHandler);
